import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm} from 'redux-form'
import FormFieldText from '../../../components/uiKit/FormFieldText'
import Button from '../../../components/uiKit/Button'


class VerifyWithPasswordForm extends React.Component{

	render(){
		const {method} = this.props
		let submitBtnColor = 'blue'

		if(method==='remove'){
			submitBtnColor = 'red'
		}
		const {externalSiginType}=this.props

		return(
			<div className='form--verifyWithPassword'>				
				<form onSubmit={this.props.handleSubmit} autoComplete='off'>				
				    <Field 
		        		name='currentPassword'
		        		label={false}
		        		type='password'
		        		size='large'		        		
				        component={FormFieldText}
				        placeholder='Password'				        
				        autoComplete={'new-password'}
				        autoFocus={true}
				    />
    				<Button 
    					submitLoading={this.props.submitLoading}
    					size='large'
    					label={method==='add' ? 'Confirm' : externalSiginType==='apple'?'Remove Apple Sign-in':'Remove Google Sign-in'}
    					color={this.props.dirty && this.props.valid ? `${submitBtnColor}` : 'gray'}
    					canSubmit={this.props.dirty && this.props.valid && !this.props.submitLoading ? true : false}
    					type='submit'>
    				</Button>	        	
	     		 </form>
			 </div>
		)
	}
}



const mapStateToProps = (state,ownProps) => {
	return {}
}

VerifyWithPasswordForm = reduxForm({
	form: 'verifyWithPasswordForm',
	enableReinitialize: true,
	autoComplete:'off'
})(VerifyWithPasswordForm)

export default connect(mapStateToProps)(VerifyWithPasswordForm)



